const languages = [
    { identifier: 'en', htmlLang: 'en', descriptor: 'english' },
    { identifier: 'pt', htmlLang: 'pt-br', descriptor: 'português' },
]

export default languages